import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useFetch from '../useFetch';
import { useNavigate } from 'react-router-dom';
import handleBackendResponse from '../../Utils/handleNotifications/handleBackendResponse';

export default function useHandleTaskRates(taskId) {
    const navigate = useNavigate(),
        fetch = useFetch(navigate);

    const { data, mutate, error, isLoading } = useSWR(`${apiBaseURL}/api/WorkTasks/Rates?taskId=${taskId}`, {
        onSuccess: (data) => console.log('Task Rates fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    const allTaskRates = data?.data.map(x => ({
        id: x.id,
        year: x.year,
        items: [
            `Industry: ${x.industry}`,
            `Federal: ${x.federal}`,
            `Overhead: ${x.overhead}`
        ]
    }));

    const handlePostTaskRate = async (formData) => {

        let body = {
            task: formData.task,
            year: formData.year,
            industry: formData.industry, 
            federal: formData.federal,
            overhead: formData.overhead
        }

        const response = await fetch.post(`${apiBaseURL}/api/WorkTasks/Rates`, body);
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood;
    }

    const handlePutTaskRate = async (formData) => {

        let body = {
            id: formData.id,
            task: formData.task,
            year: formData.year,
            industry: formData.industry, 
            federal: formData.federal,
            overhead: formData.overhead
        }

        const response = await fetch.put(`${apiBaseURL}/api/WorkTasks/Rates`, body);
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood;
    }

    return {
        allTaskRates,
        error,
        isLoading,
        handlePostTaskRate,
        handlePutTaskRate
    }
}